import { useMutation } from "react-query"
import api from "../client"
import { CreateOrderResponseData } from "../types/order"
import { queryClient } from "../query"

const postData = async () => {
    const { data } = await api.post<CreateOrderResponseData>(
        "/orders",
        {}
    )

    queryClient.invalidateQueries(["orders"], { refetchInactive: true })

    return data
}

export const useCreateOrder = () => {
    return useMutation(() => {
        return postData()
    })
}
